// extracted by mini-css-extract-plugin
module.exports = {"carBadge":"index_carBadge__3zp-G"};